import { createContext } from 'react';

export const CreationInvestorContext = createContext(null);
